<template>
  <div id="app">
    <Navbar />
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';  // Import the Navbar component

export default {
  name: "AppLayout",
  components: {
    Navbar
  }
}
</script>

<style>
@font-face {
  font-family: 'Roboto';
  src: url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');
}

::-webkit-scrollbar {
  width: 8px;
  /* Width of the scrollbar */
}

::-webkit-scrollbar-track {
  background-color: transparent;
  /* Transparent background */
}

::-webkit-scrollbar-thumb {
  background-color: #7b86f7;
  /* Primary color */
  border-radius: 4px;
  /* Rounded corners */
}

::-webkit-scrollbar-thumb:hover {
  background-color: #6c75e0;
  /* Slightly darker color on hover */
}

body {
  background-color: #e2e2e2;
}
</style>